<template>
  <div>
    <!--BEGIN-->
    <div class="form-group">
      <label>Cartella padre</label>
      <select v-model="data_parent_folder" class="form-control">
        <!--                <option value="0">-->
        <!--                    /-->
        <!--                </option>-->
        <option v-for="folder in folders_array" :value="folder.id">
          {{ folder.name }}
        </option>
      </select>
    </div>

    <input type="hidden" name="modelId" :value="this.model_id">
    <input type="hidden" name="model" :value="this.model">


    <div class="form-buttons">
      <button class="btn btn--green" type="button" @click="submitForm()">
        {{ __("misc.save") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {

  },
  data() {
    return {
      data_parent_folder: this.parent_folder
    }
  },

  methods: {
    submitForm() {
      /*
        Initialize the form data
      */
      let params = {

        "model": this.model,
        "folder": this.data_parent_folder,

        "module": this.module_name,
        "share": this.share,
        "modelId": this.model_id,
        "category": this.category

      };
      /*
    Make the request to the POST /multiple-files URL
  */

      axios.put(this.route_form,
          params,
      ).then(function (response) {


        if (response.data.closePopup) {

          app.__vue__.$refs.vue_popup.active = false;
          app.__vue__.$refs.document_sharing.readFolder(response.data.folder);

        } else {
          //add normal file, reload attachment page with url returned from server
          console.log("Document normale", response.data);
          app.__vue__.$refs.vue_popup.toggle("Allegati", response.data.urlHomeAttachments);
        }


      })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
          })
          .finally(function () {

          });

      //call sync function
      if (this.share) {
        app.__vue__.$refs.document_sharing.readFolder(this.folder);
      }


    },
  },
  props: {

    route_form: {
      type: String,
      required: true
    },

    parent_folder: {
      type: Number,
      required: true
    },

    module_name: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    share: {
      type: Number,
      required: true
    },
    model_id: {
      type: Number,
      required: true
    },
    folders_array: {
      type: Array,
      required: true
    },

  },


}
</script>

